<div class="flex flex-col w-full h-full">
  <!-- Header -->
  <div class="overflow-y-hidden">
    <div
      class="flex bg-[#F9F9FA] h-13 items-center border-b border-gray-400 text-[0.59em] xl:text-[0.7em] 2xl:text-[0.8em] text-gray-500"
    >
      <!-- Column ATTIVITÀ (2/4) -->
      <div class="flex justify-start w-2/4 min-w-[40%] pl-4">
        <h2>ATTIVITÀ</h2>
      </div>
      
      <!-- Column # (1/4) -->
      <div class="flex justify-center w-1/4 min-w-[25%]">
        <h2>#</h2>
      </div>
      
      <!-- Column COMPLETAMENTO % (1/4) -->
      <div class="flex justify-start w-1/4 min-w-[35%]">
        <h2>COMPLETAMENTO %</h2>
      </div>
    </div>
  </div>
  
  <!-- List -->
  <div class="flex flex-col w-full text-gray-900 h-full overflow-hidden relative">
    <div class="overflow-y-auto w-full scrollbar2 overflow-x-hidden">
      <ng-container *ngIf="finalList!.length > 0">
        <div
          class="flex w-full items-center py-2 h-16 border-b border-gray-100 text-gray-500"
          *ngFor="let activity of finalList; let i = index"
        >
          <!-- Column Nome Attività (2/4) -->
          <div class="flex items-center w-2/4 min-w-[40%] pl-4 h-full">
            <h4 class="patient-potential-column-region-name text-[0.6rem] 2xl:text-[0.8rem] font-light h-full flex items-center">
              {{ activity.name }}
            </h4>
          </div>

          <!-- Column Number (1/4) -->
          <div class="flex justify-center items-center w-1/4 min-w-[25%] h-full">
            <h4 class="patient-potential-column-region-name text-[0.6rem] 2xl:text-[0.8rem]">
              {{ activity.totalCountry }}
            </h4>
          </div>

          <!-- Column Progress Bar and percentage (1/4) -->
          <div class="flex items-center w-1/4 min-w-[35%] h-full pr-4">
            <div class="flex items-center w-full relative">
              <!-- Progress bar responsive -->
              <div
                class="flex w-[100px] max-2xl:w-[80px] h-2 bg-gray-200 rounded-full overflow-hidden"
                role="progressbar"
                [attr.aria-valuenow]="activity.percentageCompletion"
                [attr.aria-valuemin]="0"
                [attr.aria-valuemax]="100"
              >
                <div
                  class="flex flex-col justify-center rounded-full overflow-hidden bg-[#0A768A] transition duration-500 text-dimot-1"
                  [style.width]="activity.percentageCompletion + '%'"
                ></div>
              </div>
              <!-- Percentage -->
              <div class="absolute left-[120px] max-2xl:left-[90px]">
                <span class="text-gray-800 text-[0.6rem] 2xl:text-[0.8rem]">
                  {{ activity.percentageCompletion }}%
                </span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>